module.exports = __webpack_public_path__ + "8642144c913adbc8a97479d60dc81fb8.svg";